import gsap from "gsap";
import React, { useEffect, useRef, useState } from "react";
import crossImage from "../assets/hexagons/crossImage.svg";
import hex1Image from "../assets/hexagons/hex1Image.png";
import hex2Image from "../assets/hexagons/hex2Image.png";
import hex3Image from "../assets/hexagons/hex3Image.png";
import hex4Image from "../assets/hexagons/hex4Image.png";
import hex5Image from "../assets/hexagons/hex5Image.png";
import hex6Image from "../assets/hexagons/hex6Image.png";
import plusImage from "../assets/hexagons/plusImage.svg";

const WhyChooseParam = () => {
  const hex1Ref = useRef(null);
  const hex2Ref = useRef(null);
  const hex3Ref = useRef(null);
  const hex4Ref = useRef(null);
  const hex5Ref = useRef(null);
  const hex6Ref = useRef(null);

  const activeRef = useRef(null);

  const [active, setActive] = useState(null);

  useEffect(() => {
    // console.log('active: ', active)

    if (active !== null) {
      gsap.to(hex1Ref.current, {
        x: "-600",
        opacity: 0,
        duration: 1,
        ease: "power2.out",
      });

      gsap.to(hex2Ref.current, {
        x: "-600",
        y: "600",
        opacity: 0,
        duration: 1,
        ease: "power2.out",
      });

      gsap.to(hex3Ref.current, {
        x: "-600",
        y: "-600",
        opacity: 0,
        duration: 1,
        ease: "power2.out",
      });

      gsap.to(hex4Ref.current, {
        x: "600",
        y: "600",
        opacity: 0,
        duration: 1,
        ease: "power2.out",
      });

      gsap.to(hex5Ref.current, {
        x: "600",
        y: "600",
        opacity: 0,
        duration: 1,
        ease: "power2.out",
      });
      gsap.to(hex6Ref.current, {
        x: "600",
        opacity: 0,
        duration: 1,
        ease: "power2.out",
      });

      gsap.fromTo(
        activeRef.current,
        { x: "600", y: "600", opacity: 0 },
        { x: 0, y: 0, opacity: 1, duration: 1 }
      );
    }
  }, [active]);

  const handleCancelClick = () => {
    console.log(activeRef.current);
    gsap.to(activeRef.current, {
      x: "600",
      y: "600",
      opacity: 0,
      duration: 1,
      ease: "power1.in",
      onComplete: () => {
        setActive(null);
      },
    });

    gsap.fromTo(
      hex1Ref.current,
      { x: "-600", opacity: 0, ease: "power2.in" },
      { x: 0, opacity: 1, duration: 1, ease: "power2.in" }
    );

    gsap.fromTo(
      hex2Ref.current,
      { x: "-600", y: "600", opacity: 0, ease: "power2.in" },
      { x: 0, y: 0, opacity: 1, duration: 1, ease: "power2.in" }
    );

    gsap.fromTo(
      hex3Ref.current,
      { x: "-600", y: "-600", opacity: 0, ease: "power2.in" },
      { x: 0, y: 0, opacity: 1, duration: 1, ease: "power2.in" }
    );

    gsap.fromTo(
      hex4Ref.current,
      { x: "600", y: "600", opacity: 0, ease: "power2.in" },
      { x: 0, y: 0, opacity: 1, duration: 1, ease: "power2.in" }
    );

    gsap.fromTo(
      hex5Ref.current,
      { x: "600", y: "600", opacity: 0, ease: "power2.in" },
      { x: 0, y: 0, opacity: 1, duration: 1, ease: "power2.in" }
    );

    gsap.fromTo(
      hex6Ref.current,
      { x: "600", opacity: 0, ease: "power2.in" },
      { x: 0, opacity: 1, duration: 1, ease: "power2.in" }
    );
    // setActive(null)
  };
  const hexRefs = [hex1Ref, hex2Ref, hex3Ref, hex4Ref, hex5Ref, hex6Ref];
  const handleMouseEnter = (index) => {
    gsap.to(hexRefs[index].current, {
      scale: 1.07, // scale the element by 1.07x
      duration: 0.5, // animation duration of 0.5 seconds
      transformOrigin: "bottom left", // scale from the bottom left
    });
  };

  const handleMouseLeave = (index) => {
    gsap.to(hexRefs[index].current, {
      scale: 1, // revert to original size
      duration: 0.5, // animation duration of 0.5 seconds
      transformOrigin: "bottom left", // scale from the bottom left
    });
  };
  const hexArray = [
    {
      img: hex1Image,
      title: "Constantly Here to Assist You",
      content:
        "From your smallest questions to your most ambitious goals, our dedicated team is always here to assist you with unwavering support, tailored solutions, and proven expertise.",
    },
    {
      img: hex2Image,
      title: "Dedicated Professionals",
      content:
        "Our workforce involves a dedicated team of diverse individuals helping clients grow with each passing day. Our team loves to exceed clients’ expectations and share a long-term bonding with them.",
    },
    {
      img: hex3Image,
      title: "Specialized Customer Service Model",
      content:
        "Our system involves a well-crafted business model that focuses on the needs of the customers. Our business model implies keeping you in the center and communicating with you at every step.",
    },
    {
      img: hex4Image,
      title: "Quality Results Within Your Budget",
      content:
        "Technology is the need of the hour and should be afforded by all. We are here to change your vision toward using technology. It is not a costly investment until you optimize it in the right direction.",
    },
    {
      img: hex5Image,
      title: "Innovation at its Best",
      content:
        "Our team’s love for technology and innovation has always kept the spirits alive at work. We believe we can make a difference in society by making the best use of technology in healthcare.",
    },
    {
      img: hex6Image,
      title: "Prompt & Punctual",
      content:
        "We understand how precious your time is and guarantee to meet your expectations within time. Come picture an idea with us and we will tell you how it’s done within time.",
    },
  ];
  return (
    <div className="w-full flex justify-center overflow-hidden 2200:mt-[-100px] xl:mt-[-80px] lg:mt-[100px] 800:mt-[-160px] md:mt-[-120px] sm:mt-[30px] xs:mt-[-30px] ">
      <div className="w-full flex flex-col justify-center items-center md:gap-[60px] xs:gap-[40px]">
        {/* Text */}
        <div className="w-[90%]">
          <div className="text-center flex flex-col gap-4 animate-zoomIn">
            <h2 className="bg-gradient-to-r  from-[#1FA2FF] from-[40%] via-cyan-300 via-60% to-[#A6FFCB] to-72% text-transparent bg-clip-text font-semibold  lg:text-[56px] xs:text-[clamp(40px,5.5vw,56px)] font-[Faustina]">
              Why Choose Param
            </h2>

            <p className="text-center lg:text-[18px] md:text-[16px] xs:text-[14x]  font-normal text-white font-[Poppins] leading-[35px]">
              What Do Opportunities Say To Businesses With No Technology? They
              Say Better Luck Next Time. To Make Sure You Jump On Every
              Opportunity Available, Param Group Of Companies Offers You
              Top-Notch Engineering Solutions With Brainstorming Ideas To Shift
              You Closer To Your Targets.
            </p>
          </div>
        </div>
        {/* Hexagon */}

        <div className={` ${active !== null ? "h-0" : "h-full"} w-[10%]  `}>
          <div className="flex    lg:flex-row xl:flex-row sm:flex-col  xs:flex-col md:flex-row   justify-center items-center font-[Faustina] font-semibold xl:text-[32px] xs:text-[25px] relative  sm:py-4">
            <div className=" flex xs:flex-col  2xl:flex-row md:gap-10 xs:gap-1 relative 2xl:pt-0 xl:pt-[88%]  md:-mr-10 2xl:mr-0">
              {/* Hex 1*/}
              <div
                className="md:mb-0 xs:-mb-[100px] flex justify-center items-center relative z-10"
                ref={hex1Ref}
              >
                <div
                  className="hex hex-parent group xl:w-[277px] xl:h-[238px] md:w-[250px] lg:w-[277px] lg:h-[250px] md:h-[250px] xs:w-[250px] xs:h-[227px] bg-gradient-to-b from-[#A6FFCB] via-[#12D8FA] via-[40%] to-[#1FA2FF] to-[90%] p-1 relative"
                  onMouseEnter={() => handleMouseEnter(0)}
                  onMouseLeave={() => handleMouseLeave(0)}
                >
                  <div className="hex-inner hex bg-black w-full h-full flex justify-center relative overflow-hidden">
                    <div className="hex-shadow-inner absolute w-[100%] h-[100%] -z-10 group-hover:opacity-[0.3]"></div>

                    <div className="w-[60%] h-full flex flex-col justify-center items-center gap-4 z-20">
                      <p className="text-white text-center 1280:text-[32px] md:text-[clamp(24px,2.6vw,32px)] xs:text-[24px]">
                        Constantly Here to Assist You
                      </p>

                      <div
                        className="w-[43px] h-[43px] cursor-pointer z-30"
                        onClick={(e) => {
                          e.stopPropagation();
                          setActive(0);
                        }}
                      >
                        <img src={plusImage} alt="" className="w-full h-full" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="hex-shadow absolute w-[100%] h-[90%] top-[10px] left-[-15px] -z-10"></div>
              </div>
              {/* Hex 2 */}
              <div
                className="md:mb-0 xs:-mb-[90px] 2xl:w-[277px] 2xl:h-[525px] xl:w-[277px] xl:h-[238px] lg:w-[277px] lg:h-[250px]  md:w-[250px]  md:h-[250px] xs:w-[250px] xs:h-[227px] max-md:mt-[150px] flex justify-center items-center relative"
                ref={hex2Ref}
              >
                <div
                  className="hex hex-parent group xl:w-[277px] xl:h-[238px] lg:w-[277px] lg:h-[250px]  md:w-[250px]  md:h-[250px] xs:w-[250px] xs:h-[227px] bg-gradient-to-b from-[#A6FFCB] via-[#12D8FA] via-[40%] to-[#1FA2FF] to-[90%] p-1"
                  onMouseEnter={() => handleMouseEnter(1)}
                  onMouseLeave={() => handleMouseLeave(1)}
                >
                  <div className="hex-inner hex bg-black w-full h-full flex justify-center relative overflow-hidden">
                    <div className="hex-shadow-inner absolute w-[100%] h-[100%] z-[-1] group-hover:opacity-[0.3]"></div>

                    <div className="w-[60%] h-full flex flex-col justify-center items-center gap-4">
                      <p className="text-white text-center 1280:text-[32px] md:text-[clamp(24px,2.6vw,32px)] xs:text-[24px]">
                        Dedicated Professionals
                      </p>

                      <div
                        className="w-[43px] h-[43px] cursor-pointer"
                        onClick={() => setActive(1)}
                      >
                        <img src={plusImage} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="hex-shadow absolute w-[100%] h-[90%] top-[10px] left-[-15px]"></div>
              </div>
            </div>

            {/* Hex 3 and 4 */}
            <div
              className=" 2xl:w-[277px] 2xl:h-[625px] xl:w-[277px] xl:h-[675px] lg:w-[277px] lg:h-[850px]  md:w-[250px]  md:h-[850px] xs:w-[315px] xs:h-[477px] 
                 flex flex-col md:gap-10 xs:gap-52 max-md:mt-[150px] relative"
            >
              {/* Hex 3 */}
              <div
                className="hex hex-parent group 2xl:w-[277px] 2xl:h-[257px] lg:w-[277px] lg:h-[250px] xl:w-[277px] xl:h-[238px]  md:w-[250px]  md:h-[250px] xs:w-[250px] xs:h-[250px] lg:mb-0 xs:-mb-24 md:mb-0 bg-gradient-to-b from-[#A6FFCB] via-[#12D8FA] via-[40%] to-[#1FA2FF] to-[90%] p-1  xs:ml-8 md:ml-0"
                ref={hex3Ref}
                onMouseEnter={() => handleMouseEnter(2)}
                onMouseLeave={() => handleMouseLeave(2)}
              >
                <div className="hex-inner hex bg-black w-full h-full flex justify-center relative overflow-hidden">
                  <div className="hex-shadow-inner absolute w-[100%] h-[100%] z-[-1] group-hover:opacity-[0.3]"></div>

                  <div className="w-[72%] h-full flex flex-col justify-center items-center gap-4">
                    <p className="text-white text-center 1280:text-[32px] md:text-[clamp(24px,2.6vw,32px)] xs:text-[24px]">
                      Specialized Customer Service Model
                    </p>

                    <div
                      className="w-[43px] h-[43px] cursor-pointer"
                      onClick={() => setActive(2)}
                    >
                      <img src={plusImage} alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="hex-shadow absolute w-[100%] h-[50%] top-[10px] left-[-15px]"></div>

              {/* Hex 4 */}
              <div
                className="lg:mt-0 xs:mt-[-50px] hex hex-parent group 2xl:w-[277px] 2xl:h-[257px] lg:w-[277px] lg:h-[250px] xl:w-[277px] xl:h-[238px]  md:w-[250px]  md:h-[250px] xs:w-[260px] xs:h-[260px]   xs:ml-8 md:ml-0  lg:mb-0 xs:-mb-[80px]  md:mt-0 md:-mb-0 bg-gradient-to-b from-[#A6FFCB] via-[#12D8FA] via-[40%] to-[#1FA2FF] to-[90%] p-1 max-md:mt-[-50px]"
                ref={hex4Ref}
                onMouseEnter={() => handleMouseEnter(3)}
                onMouseLeave={() => handleMouseLeave(3)}
              >
                <div className="hex-inner hex bg-black w-full h-full flex justify-center relative overflow-hidden ">
                  <div className="hex-shadow-inner absolute w-[100%] h-[100%] z-[-1] group-hover:opacity-[0.3]"></div>

                  <div className="w-[79%] h-full flex flex-col justify-center items-center gap-4">
                    <p className="text-white text-center 1280:text-[clamp(24px,2.6vw,32px)] md:text-[clamp(24px,2.6vw,32px)] xs:text-[24px]">
                      Quality Results Within Your Budget
                    </p>

                    <div
                      className="w-[43px] h-[43px] cursor-pointer"
                      onClick={() => setActive(3)}
                    >
                      <img src={plusImage} alt="" />
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="hex-shadow absolute w-[130%] h-[90%] top-[46%] left-[-55px]"></div> */}
            </div>

            <div className=" flex xs:flex-col  2xl:flex-row md:gap-10 xs:gap-1 relative 2xl:pt-0 xl:pt-[88%] md:-ml-10 2xl:ml-0">
              {/* Hex 5*/}
              <div
                className="md:mb-0 xs:mb-[-240px] 2xl:w-[277px] 2xl:h-[525px] xl:w-[277px] xl:h-[238px] lg:w-[277px] lg:h-[250px] md:w-[250px] md:h-[250px] xs:w-[315px] xs:h-[227px] max-md:mt-[130px] flex justify-center items-center relative "
                ref={hex5Ref}
              >
                <div
                  className="hex hex-parent group xl:w-[277px] xl:h-[238px] lg:w-[277px] lg:h-[250px] md:w-[250px] md:h-[250px] xs:w-[250px] xs:h-[227px] bg-gradient-to-b from-[#A6FFCB] via-[#12D8FA] via-[40%] to-[#1FA2FF] to-[90%] p-1 relative"
                  onMouseEnter={() => handleMouseEnter(4)}
                  onMouseLeave={() => handleMouseLeave(4)}
                >
                  <div className="hex-inner hex bg-black w-full h-full flex justify-center relative overflow-hidden">
                    <div className="hex-shadow-inner absolute w-[100%] h-[100%] -z-10 group-hover:opacity-[0.3]"></div>

                    <div className="w-[60%] h-full flex flex-col justify-center items-center gap-4 z-20">
                      <p className="text-white text-center 1280:text-[32px] md:text-[clamp(24px,2.6vw,32px)] xs:text-[24px]">
                        Innovation at its Best
                      </p>

                      <div
                        className="w-[43px] h-[43px] cursor-pointer z-30"
                        onClick={(e) => {
                          e.stopPropagation();
                          setActive(4);
                        }}
                      >
                        <img src={plusImage} alt="" className="w-full h-full" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="hex-shadow absolute w-[100%] h-[90%] top-[10px] left-[-15px] -z-10"></div>
              </div>

              {/* Hex 6 */}
              <div
                className="md:mb-0 xs:mb-[0px]  2xl:w-[277px] 2xl:h-[525px] xl:w-[277px] xl:h-[238px] lg:w-[277px] lg:h-[250px]  md:w-[250px]  md:h-[250px] xs:w-[315px] xs:h-[227px] max-md:mt-[300px] flex justify-center items-center relative"
                ref={hex6Ref}
              >
                <div
                  className="hex hex-parent group xl:w-[277px] xl:h-[238px]  lg:w-[277px] lg:h-[250px] md:w-[250px]  md:h-[250px] xs:w-[250px] xs:h-[227px]  bg-gradient-to-b from-[#A6FFCB] via-[#12D8FA] via-[40%] to-[#1FA2FF] to-[90%] p-1"
                  onMouseEnter={() => handleMouseEnter(5)}
                  onMouseLeave={() => handleMouseLeave(5)}
                >
                  <div className="hex-inner hex bg-black w-full h-full flex justify-center relative overflow-hidden">
                    <div className="hex-shadow-inner absolute w-[100%] h-[100%] z-[-1] group-hover:opacity-[0.3]"></div>

                    <div className="w-[60%] h-full flex flex-col justify-center items-center gap-4">
                      <p className="text-white text-center 1280:text-[32px] md:text-[clamp(24px,2.6vw,32px)] xs:text-[24px]">
                        Prompt & Punctual
                      </p>

                      <div
                        className="w-[43px] h-[43px] cursor-pointer"
                        onClick={() => setActive(5)}
                      >
                        <img src={plusImage} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="hex-shadow absolute w-[100%] h-[90%] top-[10px] left-[-15px]"></div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`hex-detail  xs:mt-10 md:mt-0 lg:px-[70px]  items-center justify-center xs:flex-col xl:flex-row font-[Faustina] flex lg:flex-row ${
            active !== null ? "h-auto" : "h-0 overflow-hidden"
          }`}
          ref={activeRef}
        >
          <div className="img-text-container w-[95%] flex justify-center items-center mb-[40px]">
            <div className="relative img-text-inner h-full w-full flex lg:flex-row xs:flex-col items-center 1300:gap-[80px] lg:gap-[60px] xs:gap-[32px]">
              {/* Left Side - Image */}
              <div className="w-full lg:w-[40%] flex justify-center items-center relative">
                <img
                  src={hexArray[active]?.img}
                  alt=""
                  className="img-container lg:w-[100%] h-[100%] md:w-[80%] xs:w-[80%] "
                />
                {/* Close Button - Positioned at the Top-Right */}
                {/* <img
                  src={crossImage}
                  alt="Close"
                  className={`w-[40px] h-[40px] cursor-pointer 428:block 1280:hidden`}
                  onClick={handleCancelClick}
                /> */}
              </div>

              {/* Right Side - Text */}
              <div className="text-container lg:w-[50%]  flex flex-col text-white  w-[90%] text-justify">
                <p className="lg:text-[40px] xs:text-[clamp(24px,3.9vw,40px)]  md:text-start font-semibold bg-gradient-to-r from-[#1FA2FF] from-0% via-45% to-[#A6FFCB] to-92% bg-clip-text text-transparent">
                  {hexArray[active]?.title}
                </p>
                <p className="lg:text-[24px] md:text-[18px] xs:text-[16px] leading-[40px] font-normal">
                  {hexArray[active]?.content}
                </p>
              </div>
              <div className="absolute lg:top-[-50px] lg:right-0 md:right-[30px] xs:top-[-60px] xs:right-[20px] flex justify-start items-start">
                <div className="hidden lg:block md:block xs:block 1300:w-[50px] 1300:h-[50px] xs:w-[40px] xs:h-[40px] cursor-pointer">
                  <img src={crossImage} alt="" onClick={handleCancelClick} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default WhyChooseParam;
